import Menu from '@/global/components/MenuV2'
import { Grid } from '@mui/material'
import { FormField, FormFieldSelect } from 'global/components/Form'
import IconeAjuda from 'global/components/IconeAjuda'
import { useFormContext } from 'react-hook-form'

export default function FormFaltasCadastradas() {
    const { watch } = useFormContext()
    const faltaAutomatica = watch('faltaAutomatica')

    return [
        <Grid item xs={6} sm={4}>
            <FormFieldSelect
                name="faltaAutomatica"
                label="Falta padrão"
                options={[
                    {
                        label: 'Injustificada',
                        value: 'injustificada',
                    },
                    { label: 'Justificada', value: 'justificada' },
                ]}
                endAdornment={
                    <IconeAjuda className="mr-2">
                        Caso utilize controle de faltas
                        justificadas/injustificadas, selecione o tipo de falta
                        que será cadastrada automaticamente para os dias em que
                        houver faltas para os funcionários.
                        <br />
                        <br />
                        Caso selecione "Nenhuma", você ainda poderá cadastrar
                        faltas manualmente para cada funcionário.
                    </IconeAjuda>
                }
            >
                <Menu.Item value={null as any}>
                    <em>Nenhuma</em>
                </Menu.Item>
            </FormFieldSelect>
        </Grid>,
        <Grid item xs={6} sm={4}>
            <FormField
                type="time"
                name="horasFaltaAutomatica"
                label="Limite"
                disabled={!faltaAutomatica}
                InputProps={{
                    endAdornment: (
                        <div className="inline-flex items-center">
                            <span>h</span>
                            <IconeAjuda>
                                Quando definido, o sistema irá considerar a
                                falta definida no campo{' '}
                                <strong>Falta padrão</strong> apenas quando
                                faltas superarem o valor configurado neste
                                campo.
                            </IconeAjuda>
                        </div>
                    ),
                }}
                helperText="Deixe em branco para considerar o dia inteiro"
            />
        </Grid>,
        <Grid item xs={6} sm={4}>
            <FormFieldSelect
                name="horasExcedentesConsideraDiaInteiro"
                label="Horas excedentes considera dia inteiro"
                options={[
                    { label: 'Sim', value: 'true' },
                    { label: 'Não', value: 'false' },
                ]}
                endAdornment={
                    <IconeAjuda className="mr-2">
                        Caso habilitado, quando as horas de falta do funcionário
                        ultrapassarem o limite definido no campo{' '}
                        <strong>Limite</strong>, o sistema irá considerar o dia
                        inteiro como falta do tipo definido no campo{' '}
                        <strong>Falta padrão</strong>.
                        <br />
                        <br />
                        Caso desabilitado, o sistema irá considerar apenas as
                        horas excedentes como falta do tipo definido no campo{' '}
                        <strong>Falta padrão</strong>.
                    </IconeAjuda>
                }
            />
        </Grid>,
    ]
}
